import ApiConstant from "../../constants/api.constants";
import api from "../api";

const addGaana = async (payload: any) => {
  try {
      const response = await api.post(ApiConstant.addGaana,payload);
    return response.data;
  } catch (error: any) {
    console.error("Error adding gaana", error);
    return {
      isSuccess: false,
      message: error?.response?.data?.message || "Server Error",
    };
  }
};

const getAllGaanas = async () => {
  try {
      const response = await api.get(ApiConstant.getAllGaanas);
    return response.data || [];
  } catch (error) {
    console.error("Failed to fetch gaana list", error);
    return [];
  }
};
const getAllVendors = async () => {
  try {
      const response = await api.get(ApiConstant.getAllVendor);
    return response.data; 
  } catch (error) {
    console.error("Failed to fetch vendors", error);
    return [];
  }
};
const deleteGaana = async (userId: number) => {
  try {
    const result = await api.delete(ApiConstant.deleteDesiriGaana, {
      params: { userId },
    });
    return result?.data ?? { isSuccess: false, message: "Unknown error" };
  } catch (error) {
    console.error(`Error deleting user ${userId}:`, error);
    return { isSuccess: false, message: "Error deleting user" };
  }
};
const updateGaanaDetails = async (gaanaData: any) => {
  try {
    const res = await api.put(ApiConstant.updateGaanaDetails, gaanaData);
    return res.data;
  } catch (error) {
    console.error("Error updating gaana details:", error);
    return { isSuccess: false, message: "Error updating gaana details" };
  }
};
const gaanaService = {
  addGaana,
  getAllGaanas,
  getAllVendors,
  deleteGaana,
  updateGaanaDetails
};

export default gaanaService;
